<template>
    <div class="flex flex-column overflow-hidden items-center p-4 sm:p-12 md:p-16 rounded" :class="{'hover:bg-gray-150 cursor-pointer': clickable}" @click="handleClick">
        <div class="rounded-full flex items-center justify-center w-24 min-w-24 h-24 min-h-24 text-white text-sm" :class="[!hasStyleColor ? 'bg-' + stateColor : null]" :style="{backgroundColor: hasStyleColor ? stateColor : null}">
            {{ step }}
        </div>
        <div v-if="!hideDetails" class="flex flex-column w-full overflow-hidden mt-8">
			<p v-if="title" class="text-center text-2xs sm:text-sm md:text-sub leading-tight truncate mb-2" :class="[!hasStyleColor ? 'text-' + stateColor : null]" :style="{color: hasStyleColor ? stateColor : null}">{{ title }}</p>
			<span v-if="subtitle" class="text-3xs sm:text-2xs md:text-xs truncate leading-tight text-gray-400 text-center truncate">{{ subtitle }}</span>
        </div>
    </div>
</template>

<script>
import Toggleable from "../../mixins/Toggleable";
    import Clickable from "../../mixins/Clickable";

    export default {

        name: 'WizardStepHeader',

        mixins: [Toggleable, Clickable],

        props: {
            color: {
                type: String,
                default: 'primary'
            },

            // Whether the step shall retrieve a 'done' state
            done: {
                type: Boolean,
                default: false
            },

            // The index / position of the step
            step: {
                type: [Number, String],
                required: true
            },

            // The title to display
            title: {
                type: String,
                default: null
            },

            // The subtitle to display
            subtitle: {
                type: String,
                default: null
            },

            // Whether to hide the title and subtitle data of the step
            hideDetails: {
                type: Boolean,
                default: false
            },
        },

        computed: {
            stateColor() {
                if (this.isActive) {
                    return this.color;
                }
                if (this.done) {
                    return 'success';
                }

                return 'gray-400'
            },

            hasStyleColor() {
                return this.stateColor && (this.stateColor.startsWith('#') || this.stateColor.startsWith('rgb'))
            }
        }


    }
</script>